import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUiStore } from '@/store/ui.store';

/**
 * LA DIRECCIÓN `/athena` YA NO ES UNA PÁGINA.
 *
 * Athena es una ventana, pero la dirección sigue existiendo: la tienen el menú,
 * la barra del teléfono, el buscador de comandos y cualquier enlace guardado.
 * Quien llegue por ahí abre la ventana y vuelve a donde estaba; quien entra
 * directo, sin pantalla anterior, cae en el inicio con la ventana abierta.
 */
export function AbrirAthena() {
  const abrir = useUiStore((s) => s.abrirAthena);
  const navegar = useNavigate();
  const ubicacion = useLocation();

  useEffect(() => {
    abrir();
    // `default` es la llave de la primera entrada del historial: no hay atrás.
    if (ubicacion.key === 'default') navegar('/', { replace: true });
    else navegar(-1);
    // Corre una vez, al llegar a la dirección.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
